export default __webpack_public_path__ + "20ce5779acdef4bd75210a2a81935768.png";